import PipelineListPageContainer from './containers/PipelineListPageContainer'

export default PipelineListPageContainer
